module.exports = __webpack_public_path__ + "img/background.a7b1d5a4.svg";